/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.button {
  display: inline-block;
  position: relative;
  padding-inline: calc(var(--spacing, 0.25rem) * 4);
  padding-block: calc(var(--spacing, 0.25rem) * 3);
  --tw-leading: 1;
  line-height: 1;
  white-space: nowrap;
  border-radius: var(--radius-sm, 0.25rem);
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: transparent;
  cursor: pointer;
  --tw-border-style: solid;
  border-style: solid;
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  --tw-leading: calc(var(--spacing, 0.25rem) * 3);
  line-height: calc(var(--spacing, 0.25rem) * 3);
  height: calc(var(--spacing, 0.25rem) * 10);
}
.label {
  display: contents;
}
.button.small {
  padding-inline: calc(var(--spacing, 0.25rem) * 3);
  padding-block: calc(var(--spacing, 0.25rem) * 2);
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  height: calc(var(--spacing, 0.25rem) * 8);
}
.button svg {
  margin-right: calc(var(--spacing, 0.25rem) * 2);
  pointer-events: none;
}
.button[disabled] {
  opacity: 30%;
  cursor: not-allowed;
}
.primary, button.primary {
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  background-color: var(--color-primary-500);
  color: var(--color-primary-overlay-500);
}
.primary:hover, button.primary:hover {
  background-color: var(--color-primary-900);
}
.primary:hover, button.primary:hover, .secondary:hover, .tertiary:hover {
  box-shadow: 3px 3px 0px 0px rgba(0, 0, 0, 0.45);
}
.secondary {
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  color: var(--color-primary-600);
  border-color: var(--color-primary-600);
  background-color: transparent;
}
.secondary:hover {
  background-color: var(--color-gray-200, #e5e5e5);
}
.tertiary:hover {
  background-color: var(--color-gray-100, #f5f5f5);
}
button.danger {
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  background-color: var(--color-red-700, oklch(50.5% 0.213 27.518));
  color: var(--color-white, #fff);
}
.danger:hover {
  background-color: var(--color-red-900, oklch(39.6% 0.141 25.723));
}
.tertiary {
  color: var(--color-primary-600);
  background-color: transparent;
  text-decoration-line: underline;
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-leading: initial;
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}
